<footer>© Copyright {{currentYear}}. All rights reserved.</footer>